// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"commit-record_cardContainer__dptct"};